import React from 'react';
import {ExhibitInformationData} from "types/Exhibit";
import {AudioIcon} from "components/Icon/custom";
import AudioList from "pages/Exhibit/Preview/AudioList";
import FactList from "pages/Exhibit/Preview/FactList";
import InformationList from "pages/Exhibit/Preview/InformationList";
import {AudioFile} from "types/MediaFile";
import {FactData} from "types/Fact";

type Props = {
    description?: string | null
    audio: Array<AudioFile>
    facts: Array<FactData>
    information: Array<ExhibitInformationData>
}

function ExhibitInformation({description, audio, facts, information}: Props) {
    return (
        <>
            {/* Audio */}
            {!!audio.length &&
                <div className="bg-white mt-2 divide-y divide-gray-200">
                    <div className="flex items-center px-8 py-5">
                        <AudioIcon className="text-brand h-6 w-6"/>
                        <h2 className="ml-1 font-medium text-lg">Audio</h2>
                    </div>
                    <AudioList files={audio}/>
                </div>
            }

            {/* Information */}
            <div className="bg-white mt-2 divide-y divide-gray-200">
                {!!description &&
                    <div className="px-8 py-5 ">
                        <h2 className="font-medium text-lg">Description</h2>
                        <p className="font-medium text-sm text-gray-500 mt-1">{description}</p>
                    </div>
                }

                {!!facts.length &&
                    <div className="px-8 py-5">
                        <h2 className="font-medium text-lg">Exhibit Facts</h2>
                        <FactList facts={facts}/>
                    </div>
                }

                {!!information.length &&
                    <div className="px-8 py-5">
                        <h2 className="font-medium text-lg">Information</h2>
                        <InformationList sections={information}/>
                    </div>
                }
            </div>
        </>
    );
}

export default ExhibitInformation;